module.exports = __webpack_public_path__ + "static/NudistaSemiBold-2524dc2c99717216398d31705e058e15.ttf";